<template>
<div id="page-solicitud-pago-garantia" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <base-material-card color="primary" icon="library_books" title="Solicitud de Pago de Cuenta Aduanera" class="elevation-1 px-5 py-3" >
          <v-card-actions>

            <v-spacer></v-spacer>
            <v-dialog v-model="modal" max-width="80%" >
              <v-card>
                <v-card-title>
                  <v-card class="primary white--text titulomodal" >
                    <v-icon class="white--text" >{{update ? "edit" : "add"}}</v-icon>&nbsp;
                    <span class="subheading" >
                      <strong>Detalles de la Carga</strong>
                    </span>
                  </v-card>
                  <v-spacer></v-spacer>
                  <v-btn icon @click.native="modal = false" class="close_modal" >
                    <v-icon class="white--text" >cancel</v-icon>
                  </v-btn>
                </v-card-title>

                <v-card-text>
                  <v-form ref="form" lazy-validation>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs4>
                          <v-text-field label="Institución Emisora" v-model="model.institucion_emisora" :rules="[rules.required]" ></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field label="Emisora" v-model="model.emisora" :rules="[rules.required]" ></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field label="Numero Cuenta" v-model="model.numero_cuenta" :rules="[rules.required]" ></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout wrap>
                        <v-flex xs4>
                          <v-text-field label="Folios Constancia" v-model="model.folios_constancia" :rules="[rules.required]" ></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_constancia" label="Fecha Constancia" color="secondary" prepend-icon="event" @blur="model.fecha_constancia = parseDate(model.fecha_constancia)" v-mask="'####-##-##'"
                                  :rules="[rules.required]" ></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_constancia" color="secondary"  scrollable locale="es-mx" @input="menu1 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu1 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field label="Tipo Cuenta" v-model="model.tipo_cuenta" :rules="[rules.required]" ></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout wrap>
                        <v-flex xs4>
                          <v-text-field label="Cantidad" v-model="model.cantidad" ></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field label="Valor Unitario" v-model="model.valor_unitario" ></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field label="Total Garantia" v-model="model.total_garantia" :rules="[rules.required, rules.numeric]" ></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout wrap>
                        <v-flex xs4>
                          <v-text-field label="Clave Garantia" v-model="model.clave_garantia" :rules="[rules.required]" ></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field label="Titulos Asignados" v-model="model.titulos_asignados" ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn @click.native="modal=false" >
                    <v-icon>cancel</v-icon> Cancelar
                  </v-btn>
                  <v-btn color="success" @click.native="updateTrafico()" >
                    <v-icon>done</v-icon>
                    {{ update ? "Actualizar" : "Guardar" }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-actions>

          <v-card-text>
            <div id="datagrid" v-on:keyup.enter="$refs.pagination_pw.filterData()" >

              <v-client-table ref="vuetable" :data="traficos.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                <template slot="noResults" >
                  <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                </template>
                <template slot="eta" slot-scope="props" >
                  <div class="" >
                    {{parseDate(props.row.eta)}}
                  </div>
                </template>
                <template slot="actions" slot-scope="props" >
                  <v-speed-dial :id="props.row.id" direction="left" open-on-hover :style="'text-align:center;'" >
                    <template v-slot:activator>
                      <v-btn :id="props.row.id" x-small fab dark color="primary" >
                        <v-icon>reorder</v-icon>
                      </v-btn>
                    </template>

                    <v-btn center x-small fab dark color="warning" @click.native="getTrafico(props.row.referencia)" title="Editar Registro" v-tippy>
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </v-speed-dial>
                </template>
              </v-client-table>
              <template>
                <div v-if="pwPagination.total > 0" >
                  <div class="mt-3" >
                    <PaginacionComponent ref="pagination_pw" :total='pwPagination.total' :links="pwPagination.links" :items="traficos" :options="pwPagination.options" ></PaginacionComponent>
                  </div>
                </div>
              </template>
            </div>
          </v-card-text>
          </v-card>
        </base-material-card>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import PaginacionComponent from '@/components/PaginacionComponent.vue';
import axios from "axios";
import moment from "moment";

export default {
  components: {
    "PaginacionComponent": PaginacionComponent,
  },
  created: function() {
    this.model.rfc = this.$local_storage.get("rfc");
    this.getTraficos();
  },
  mounted: function() {
    this.model_filters = this.$refs.vuetable.query
  },
  watch: {
    model_filters: {
      handler(val) {
        this.pwPagination.options.filters = {
          rfc: this.model.rfc,
          referencia: {
            '$regex': this.model_filters.referencia
          }
        }
      },
      deep: true
    }
  },
  data() {
    return {
      model_filters: '',
      name: "datagrid",
      columns: [
        "seguidor",
        "referencia",
        "tipo_oper",
        "aduana",
        "AA",
        "embarcador_destinatario",
        "manifiesto",
        "contrs",
        "contenedor",
        "eta",
        "operador",
        "mensaje",
        "estado",
        "actions"
      ],
      show_loading: true,
      menu1: false,
      options: {
        filterable: ["referencia"],
        sortable: ["seguidor"],

        headings: {
          seguidor: "Seguidor",
          referencia: "Referencia",
          tipo_oper: "Tipo Operación",
          aduana: "Aduana",
          AA: "AA",
          embarcador_destinatario: "Embarcador",
          manifiesto: "Manifiesto",
          contrs: "#Contenedores",
          contenedor: "Contenedor",
          eta: "ETA",
          operador: "Operador",
          mensaje: "Mensaje",
          estado: "Estado",
          actions: "Operaciones"
        }
      },
      show_loading: true,
      breadcrumbs: [
        {
            text: "Inicio",
            disabled: false,
            href: "/trafico_index"
        },
        {
            text: "Administración",
            disabled: true,
            href: ""
        },
        {
          text: "Solicitud de Pago de Cuenta Aduanera",
          disabled: true,
          href: ""
        }
      ],
      title: "",
      modal: false,
      update: false,
      model: {
        referencia: '',
        rfc: '',
        institucion_emisora: '',
        emisora: '',
        numero_cuenta: '',
        folios_constancia: '',
        fecha_constancia: '',
        tipo_cuenta: '',
        clave_garantia: '',
        valor_unitario: '',
        total_garantia: '',
        cantidad: '',
        titulos_asignados: ''
      },
      pwPagination: {
        total: 0,
        links: {
          url: this.$hostname + "traficos/listado_solicitudes/",
          next: '',
          prev: '',
        },
        options: {
          tipo: 1,
          size: 10,
          loading: this.showLoading,
          filters: {
            rfc: '',
          }
        }
      },
      rules: {
        required: v => !!v || "Este campo es requerido",
        numeric: value => {
          const pattern = /^[\d]*$/;
          return pattern.test(value) || "Solo se permiten números";
        }
      },
      search: "",
      traficos: {
        items: []
      },
    };
  },

  methods: {
    openModal: function(type) {
      if (type === 1)
        this.update = false;
      else
        this.update = true;

      this.modal = true;
    },
    getTraficos: function() {
      axios
        .post(this.$hostname + "traficos/listado_solicitudes/", {
          'rfc': this.model.rfc
        })
        .then(response => {
          // let datos = [];
          // datos = response.data.filter(trafico => trafico.movimientos[trafico.movimientos.length > 0 ? trafico.movimientos.length-1 :0].estado == "Confirmacón de Carga");
          this.traficos.items = response.data.results;

          this.pwPagination.total = response.data.count;
          this.pwPagination.links.next = response.data.next;
          this.pwPagination.links.prev = response.data.previous;
          this.$root.$dialogLoader.hide();
        })
        .catch(error => {
          console.log(error)
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los traficos.",
            footer: ""
          });
        });
    },
    getTrafico: function(referencia) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

      axios
        .post(this.$hostname + "traficos/obtener/", {
          'rfc': this.model.rfc,
          "referencia": referencia
        })
        .then(response => {
          if (response.data.cuenta_aduanera != null && response.data.cuenta_aduanera != undefined) {
            this.model = response.data.cuenta_aduanera;
            this.model.fecha_constancia = this.parseDate(this.model.fecha_constancia)
          }
          this.model.referencia = referencia;
          this.model.rfc = this.$local_storage.get("rfc"),
            this.$root.$dialogLoader.hide();

          this.openModal(2);
        })
        .catch(error => {
          console.log(error)
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener el trafico",
            footer: ""
          });
        });
    },
    updateTrafico: function() {
      if (this.$refs.form.validate()) {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        for (let attr in this.model) {
          if (this.model[attr] == '' || this.model[attr] == null) {
            delete this.model[attr];
          }
        }

        if (this.model.fecha_constancia != null && this.model.fecha_constancia != undefined && this.fecha_constancia != '') {
          this.model.fecha_constancia = this.model.fecha_constancia + "T00:00:01"
        }
        axios
          .put(this.$hostname + "traficos/pago_cuenta_aduanera/", this.model)
          .then(response => {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El Trafico se actualizó correctamente.",
              footer: ""
            });

            this.$root.$dialogLoader.hide();
            this.getTraficos();
            this.modal = false;
          })
          .catch(error => {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al actualizar el trafico",
              footer: ""
            });
          });
      }
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
  }
};
</script>
